import React, { useState } from 'react';
import Customs from './Customs';
import FreightForwarding from './FreightForwarding';
import Login from './Login';
import Home from './Home';
import FraudDetection from './FraudDetection';
import RouteOptimization from './RouteOptimization';
import logo from './logo.svg';
import './App.css';

const USERS = [
  { username: 'admin', password: 'admin123', role: 'admin' },
  { username: 'customsuser', password: 'customs123', role: 'customs' },
  { username: 'freightuser', password: 'freight123', role: 'freight' },
];

function App() {
  const [page, setPage] = useState('home');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [username, setUsername] = useState('');
  const [role, setRole] = useState('');

  const handleLogin = (usernameInput, password) => {
    const user = USERS.find(u => u.username === usernameInput && u.password === password);
    if (user) {
      setIsAuthenticated(true);
      setLoginError('');
      setPage('home');
      setUsername(user.username);
      setRole(user.role);
    } else {
      setLoginError('Invalid username or password');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setPage('home');
    setUsername('');
    setRole('');
  };

  // Allowed modules by role
  const allowedModules = role === 'admin'
    ? ['home', 'customs', 'freight', 'fraud', 'route']
    : role === 'customs'
      ? ['home', 'customs', 'route']
      : role === 'freight'
        ? ['home', 'freight', 'route']
        : [];

  // If user tries to access a forbidden page, redirect to allowed
  React.useEffect(() => {
    if (isAuthenticated && !allowedModules.includes(page)) {
      setPage(allowedModules[0] || 'home');
    }
  }, [isAuthenticated, page, allowedModules]);

  if (!isAuthenticated || page === 'login') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6fa' }}>
        <Login onLogin={handleLogin} error={loginError} />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f4f6fa' }}>
      {/* Sidebar */}
      <div style={{
        width: 220,
        background: '#1a355e',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        padding: '32px 0',
        boxShadow: '2px 0 12px rgba(0,0,0,0.04)',
        zIndex: 2
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 40 }}>
          <img src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f69a.svg" alt="Logistics Logo" style={{ width: 48, height: 48, marginBottom: 8 }} />
          <span style={{ fontWeight: 'bold', fontSize: 18, textAlign: 'center', letterSpacing: 1, lineHeight: 1.2 }}>Swift Logistics ERP</span>
        </div>
        <button onClick={() => setPage('home')} style={navBtnStyle(page === 'home')}>Home</button>
        {allowedModules.includes('customs') && (
          <button onClick={() => setPage('customs')} style={navBtnStyle(page === 'customs')}>Customs</button>
        )}
        {allowedModules.includes('freight') && (
          <button onClick={() => setPage('freight')} style={navBtnStyle(page === 'freight')}>Freight Forwarding</button>
        )}
        {allowedModules.includes('route') && (
          <button onClick={() => setPage('route')} style={navBtnStyle(page === 'route')}>Route Optimization</button>
        )}
        {role === 'admin' && (
          <button onClick={() => setPage('fraud')} style={navBtnStyle(page === 'fraud')}>Fraud Detection</button>
        )}
        <div style={{ flex: 1 }} />
      </div>
      {/* Main Content */}
      <div style={{ flex: 1, padding: '40px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
        {/* User info and logout top right */}
        <div style={{ position: 'absolute', top: 24, right: 40, zIndex: 10, display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ background: '#eaf0fa', color: '#1a355e', padding: '7px 18px', borderRadius: 20, fontWeight: 500, fontSize: 15, boxShadow: '0 2px 8px rgba(26,53,94,0.07)', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span role="img" aria-label="user">👤</span> {username}
          </span>
          <button onClick={handleLogout} style={{ background: '#dc3545', color: '#fff', border: 'none', borderRadius: 20, padding: '7px 18px', fontWeight: 500, fontSize: 15, cursor: 'pointer', boxShadow: '0 2px 8px rgba(220,53,69,0.07)' }}>Logout</button>
        </div>
        <div style={{ width: '100%', maxWidth: 900 }}>
          {page === 'home' ? (
            <Home setPage={setPage} />
          ) : page === 'customs' && allowedModules.includes('customs') ? (
            <Customs />
          ) : page === 'freight' && allowedModules.includes('freight') ? (
            <FreightForwarding />
          ) : page === 'route' && allowedModules.includes('route') ? (
            <RouteOptimization />
          ) : page === 'fraud' && role === 'admin' ? (
            <FraudDetection />
          ) : null}
        </div>
      </div>
    </div>
  );
}

function navBtnStyle(active, isBottom) {
  return {
    background: active ? '#2e4a7d' : 'none',
    color: '#fff',
    border: 'none',
    textAlign: 'left',
    padding: '14px 32px',
    fontSize: 17,
    fontWeight: active ? 'bold' : 'normal',
    cursor: 'pointer',
    outline: 'none',
    borderTop: isBottom ? '1px solid #2e4a7d' : 'none',
    borderBottom: 'none',
    marginTop: isBottom ? 16 : 0,
    marginBottom: isBottom ? 0 : 0,
    transition: 'background 0.2s',
    width: '100%',
    letterSpacing: 0.5
  };
}

export default App;
